import { addCallback } from '../lib/teact/teactn';
import type { GlobalState } from '../global/types';

import { reloadAccessControl } from './accessControlStore';
import { pullRemoteUserData } from './centralDb/pullSnapshots';
import { isCentralDbEnabled } from './centralDb/config';
import { deferRasiHeavyWork, shouldPauseRasiBackgroundWork } from './rasitechPerf';

const PULL_COOLDOWN_MS = 60_000;

let lastPulledUserId: string | undefined;
let lastPullAt = 0;

export function initRemoteCloudSync() {
  if (typeof window === 'undefined' || !isCentralDbEnabled()) return;

  addCallback((global: GlobalState) => {
    if (global.auth.state !== 'authorizationStateReady' || !global.currentUserId) {
      return;
    }
    if (!global.isSynced || shouldPauseRasiBackgroundWork(global)) return;

    const userId = global.currentUserId;
    const now = Date.now();
    if (userId === lastPulledUserId && now - lastPullAt < PULL_COOLDOWN_MS) {
      return;
    }

    lastPulledUserId = userId;
    lastPullAt = now;

    deferRasiHeavyWork(() => {
      void reloadAccessControl();
      void pullRemoteUserData(userId);
    });
  });
}
